/*
 * @author        zach.william@zumper.com (Zach William)
 * @copyright     Copyright (c) 2021, Zumper
 * @description   Handle date function for date buttons and text inputs
 */

import isAfter from 'date-fns/isAfter'
import { useCallback } from 'react'

import { UndefinedOrDate } from '../types'

import { isOverIgnored } from './dateWithinHelpers'

export const useHandleDate = (
  startDate: UndefinedOrDate,
  setStartDate: Function,
  endDate: UndefinedOrDate,
  setEndDate: Function,
  errorCallback: Function,
  setErrors: Function,
  disabledRanges?: ReadonlyArray<readonly [startDate: Date, endDate: Date]>,
  singleCalendar?: boolean
) =>
  useCallback(
    (date: Date) => {
      const errors = errorCallback(date, startDate, endDate)
      setErrors(errors)
      if (errors.length) {
        return
      }

      if (singleCalendar) {
        if (date === startDate) {
          setStartDate(undefined)
          setEndDate(undefined)
          return
        }
        setStartDate(date)
        setEndDate(date)
        return
      }

      if (startDate === undefined) {
        setStartDate(date)
        return
      }

      if (endDate === undefined) {
        const after = isAfter(startDate, date)
        if (after) {
          if (isOverIgnored(disabledRanges, date, startDate)) {
            setStartDate(date)
            return
          }
          setEndDate(startDate)
          setStartDate(date)
        } else {
          if (isOverIgnored(disabledRanges, startDate, date)) {
            setStartDate(date)

            return
          }
          setEndDate(date)
        }
        return
      }

      setStartDate(date)
      setEndDate(undefined)
    },
    [
      startDate,
      setStartDate,
      endDate,
      setEndDate,
      errorCallback,
      setErrors,
      disabledRanges,
      singleCalendar,
    ]
  )
